var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHomepageSubjectEnglishBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m8.663 24.562-.936 2.84 2.815-.928.875-.357.848.489A10.443 10.443 0 0 0 17.5 28c5.799 0 10.5-4.7 10.5-10.5 0-5.799-4.701-10.5-10.5-10.5S7 11.703 7 17.501c0 1.974.543 3.814 1.485 5.388l.479.798-.301.875Zm1.91 1.902ZM6.77 23.917A12.442 12.442 0 0 1 5 17.501c0-6.903 5.596-12.5 12.5-12.5S30 10.598 30 17.501c0 6.904-5.596 12.5-12.5 12.5-2.27 0-4.399-.605-6.234-1.662a1.012 1.012 0 0 1-.067.024l-4.73 1.56a1 1 0 0 1-1.263-1.263l1.56-4.73.004-.013Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.366 15.35v1.42h2.29v1.32h-2.29v1.54h2.59V21h-4.3v-7.02h4.3v1.37h-2.59ZM23.346 21h-1.71l-2.86-4.33V21h-1.71v-7.02h1.71l2.86 4.35v-4.35h1.71V21Z",
  fill: "#000"
})));
export default SvgHomepageSubjectEnglishBlack;